"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var getCategory_1 = require("utils/helpers/getCategory");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
require("./MoveUserToGroup.scss");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Selector = function (props) {
    var options = [];
    var groupOptions = props.groups
        ? props.groups.reduce(function (result, item) {
            var cat = item.category;
            if (cat.type === 'SokoBidAdminUserGroup' ||
                cat.type === 'ProjectAdminUserGroup' ||
                cat.type === 'SuperAdminUserGroup' ||
                cat.type === 'SalesmanUserGroup' ||
                cat.type === 'CustomerAdminUserGroup' ||
                cat.type === 'CustomerVisibilityUserGroup' ||
                (cat.type === 'NormalUserGroup' && cat.id === -1)) {
                return __spreadArray(__spreadArray([], result, true), [
                    {
                        id: cat.id,
                        name: cat.name,
                        type: 'category',
                        options: [cat]
                    }
                ], false);
            }
            var groups = item.groups.reduce(function (r, i) {
                return __spreadArray(__spreadArray([], r, true), [__assign(__assign({}, i), { type: 'group' })], false);
            }, []);
            return __spreadArray(__spreadArray([], result, true), [
                {
                    id: cat.id,
                    name: (0, getCategory_1.getCategoryName)(cat),
                    type: 'category',
                    options: groups
                }
            ], false);
        }, options)
        : [];
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'selector', alignment: 'left' },
        React.createElement(sok_ui_1.TextInput, { editable: false, value: props.value && props.value.name !== ''
                ? props.value.name
                : (0, translation_1.getLocalization)('userfront/project/teamMembers/inviteToProject/selectGroup'), iconRight: React.createElement("span", { className: 'icon-container' },
                React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: 'move-user-to-group-modal-dropdown' }, groupOptions.map(function (z, key) {
            return (React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Dropdown2MenuItem, { key: key, selected: false, disabled: true }, React.createElement("strong", null, z.name)),
                z.options &&
                    z.options.map(function (y, key) {
                        return (React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.onChange(y); }, key: key },
                            React.createElement("span", null, y.name)));
                    })));
        }))));
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('selectedGroup', 'setSelectedGroup', undefined), recompose_1.pure);
var closeModal = function (props) {
    props.setSelectedGroup(undefined);
    props.onClose();
};
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: "move-user-to-group-modal" },
    React.createElement(sok_ui_1.Header, { onClose: function () { return closeModal(props); } }, (0, translation_1.getLocalization)(props.moveOrCopy === 'MOVE'
        ? 'components/modals/moveUserToGroup/title'
        : 'components/modals/moveUserToGroup/copy_title')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement("div", { className: 'content' },
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('components/modals/moveUserToGroup/saving')),
                React.createElement("span", null, (0, translation_1.getLocalization)(props.moveOrCopy === 'MOVE'
                    ? 'components/modals/moveUserToGroup/saving_success'
                    : 'components/modals/moveUserToGroup/copy_saving_success')),
                React.createElement("span", null, (0, translation_1.getLocalization)('components/modals/moveUserToGroup/saving_failed'))),
            React.createElement("div", { className: 'column' },
                React.createElement(Selector, { groups: props.groups, value: props.selectedGroup, onChange: props.setSelectedGroup })),
            React.createElement("div", { className: 'column rows' }, props.users.map(function (item) { return (React.createElement("div", { key: item.user.uuid, className: 'row' },
                React.createElement("div", { className: 'email-tag' },
                    React.createElement("span", null, item.user.email),
                    React.createElement("span", { className: 'fa fa-times close', onClick: function () {
                            props.onUserRemove(item.user, item.group);
                        } })))); })))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.status !== 'STANDBY' ||
                !props.selectedGroup ||
                props.users.length === 0, onClick: function () {
                return props.selectedGroup &&
                    props.onSave(props.users.map(function (x) { return (__assign(__assign({}, x.user), { profile: x.group ? x.group.id : undefined })); }), props.selectedGroup);
            }, text: (0, translation_1.getLocalization)('components/modals/moveUserToGroup/save') }),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return closeModal(props); }, text: (0, translation_1.getLocalization)('components/modals/moveUserToGroup/cancel') })))); });
